import de from './de.js'
import fr from './fr.js'

const translationsObject = {
    de,
    fr
}

export default translationsObject